var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464646"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 237,
    x2: 262.179,
    xlinkHref: "#lg1",
    y1: 80.75,
    y2: 80.75
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464646",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 237,
    x2: 262.179,
    xlinkHref: "#lg2",
    y1: 80.75,
    y2: 80.75
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 190,
    x2: 289,
    xlinkHref: "#lg1",
    y1: 100.253,
    y2: 100.253
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 89.5,
    y2: 112.5
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76ccf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#518ef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981f8"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.611,
    x2: 545.972,
    xlinkHref: "#lg3",
    y1: 173.376,
    y2: 643.737
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4071f7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569f"
  }))), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.602,
    x2: 307.834,
    xlinkHref: "#lg4",
    y1: 256.829,
    y2: 211.06
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.215,
    x2: 316.801,
    xlinkHref: "#lg4",
    y1: 335.466,
    y2: 220.052
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.459,
    x2: 347.345,
    xlinkHref: "#lg4",
    y1: 209.326,
    y2: 173.212
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.279,
    x2: 363.034,
    xlinkHref: "#lg4",
    y1: 275.17,
    y2: 188.925
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.529,
    x2: 363.968,
    y1: 159.62,
    y2: 190.059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7304,
    stopColor: "#db4735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82f3c"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.529,
    x2: 363.968,
    y1: 236.867,
    y2: 267.306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d66d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453d81"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.153,
    x2: 402.591,
    y1: 198.243,
    y2: 228.682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7e07d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e69642"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.906,
    x2: 325.345,
    y1: 198.243,
    y2: 228.682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7dc03a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e6e66"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.224,
    x2: 185.551,
    xlinkHref: "#lg4",
    y1: 423.291,
    y2: 341.618
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.742,
    x2: 304.648,
    xlinkHref: "#lg4",
    y1: 473.439,
    y2: 340.345
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.513,
    x2: 220.769,
    xlinkHref: "#lg3",
    y1: 299.58,
    y2: 376.835
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.18,
    x2: 351.436,
    xlinkHref: "#lg3",
    y1: 299.58,
    y2: 376.835
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.573,
    x2: 31.374,
    xlinkHref: "#lg4",
    y1: 306.275,
    y2: 96.076
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.079,
    x2: 185.793,
    xlinkHref: "#lg4",
    y1: 405.103,
    y2: 341.818
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.141,
    x2: 313.25,
    xlinkHref: "#lg4",
    y1: 388.541,
    y2: 338.649
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.68,
    x2: 213.244,
    xlinkHref: "#lg1",
    y1: 310.746,
    y2: 369.31
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.667,
    x2: 189.667,
    xlinkHref: "#lg2",
    y1: 335.333,
    y2: 380.745
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.346,
    x2: 343.911,
    xlinkHref: "#lg1",
    y1: 310.746,
    y2: 369.31
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.333,
    x2: 320.333,
    xlinkHref: "#lg2",
    y1: 327.333,
    y2: 388.033
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.885,
    x2: 112.885,
    xlinkHref: "#lg4",
    y1: 429.937,
    y2: 525.98
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.115,
    x2: 397.115,
    xlinkHref: "#lg4",
    y1: 429.937,
    y2: 525.98
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 185.681,
    y2: 119.588
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.739,
    x2: 194.563,
    xlinkHref: "#lg1",
    y1: 167.442,
    y2: 259.266
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.725,
    x2: 151.725,
    xlinkHref: "#lg2",
    y1: 250,
    y2: 275.005
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.149,
    x2: 154.605,
    xlinkHref: "#lg1",
    y1: 244.851,
    y2: 219.307
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m242.494 12.505v136.489c0 6.907 5.599 12.505 12.505 12.505 6.907 0 12.506-5.599 12.506-12.505v-136.489c.001-6.906-5.598-12.505-12.505-12.505-6.907 0-12.506 5.599-12.506 12.505z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.494 12.505v136.489c0 6.907 5.599 12.505 12.505 12.505 6.907 0 12.506-5.599 12.506-12.505v-136.489c.001-6.906-5.598-12.505-12.505-12.505-6.907 0-12.506 5.599-12.506 12.505z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.333 124.546h-130.666v-25.703c0-12.638 10.245-22.882 22.882-22.882h84.902c12.638 0 22.882 10.245 22.882 22.882z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.333 124.546h-130.666v-25.703c0-12.638 10.245-22.882 22.882-22.882h84.902c12.638 0 22.882 10.245 22.882 22.882z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m507.78 395.634-28.98-132.28c-19.717-89.997-99.424-154.133-191.556-154.133h-64.488c-92.131 0-171.839 64.136-191.556 154.133l-28.98 132.28c-12.873 58.758 31.871 114.366 92.023 114.366 38.21 0 72.635-23.08 87.147-58.427 27.015-65.801 120.204-65.801 147.22 0 14.512 35.347 48.937 58.427 87.147 58.427 60.152 0 104.896-55.608 92.023-114.366z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m298.142 235.68 207.727 207.74c4.589-14.894 5.542-31.215 1.912-47.786l-5.318-24.274-170.119-169.88c-4.462-5.738-39.939 29.74-34.202 34.2z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.78 395.634-5.304-24.211-135.159-134.97c-4.461-5.737-39.938 29.74-34.202 34.201l172.753 172.764c4.589-14.893 5.543-31.213 1.912-47.784z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m480.771 272.351-109.663-109.509c-4.461-5.737-39.938 29.74-34.202 34.201l163.1 163.111z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.785 272.414-74.703-74.598c-4.461-5.737-39.938 29.74-34.202 34.201l128.126 128.134z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 351.714,
    cy: 177.805,
    fill: "url(#SVGID_10_)",
    r: 24.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.714,
    cy: 255.051,
    fill: "url(#SVGID_11_)",
    r: 24.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.337,
    cy: 216.428,
    fill: "url(#SVGID_12_)",
    r: 24.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.09,
    cy: 216.428,
    fill: "url(#SVGID_13_)",
    r: 24.38
  })), /*#__PURE__*/React.createElement("path", {
    d: "m236.432 305.236c-11.36-13.1-100.363 75.903-87.262 87.262l41.817 41.817c34.854-47.919 113.224-42.172 137.624 17.258 14.511 35.347 48.936 58.427 87.146 58.427 7.862 0 15.457-.958 22.698-2.741z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.726 443.863-138.628-138.627c-11.36-13.1-100.363 75.903-87.262 87.262l31.346 32.636c.681.682 1.351 1.38 2.01 2.093l.171.178v.003c6.174 6.714 11.387 14.765 15.246 24.164 14.513 35.348 48.938 58.428 87.148 58.428 43.018 0 78.15-28.443 89.969-66.137z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.667 407.641c-34.137 0-61.908-27.772-61.908-61.908s27.771-61.908 61.908-61.908c34.136 0 61.907 27.771 61.907 61.908s-27.771 61.908-61.907 61.908z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.334 407.641c-34.137 0-61.908-27.772-61.908-61.908s27.771-61.908 61.908-61.908c34.136 0 61.907 27.771 61.907 61.908s-27.771 61.908-61.907 61.908z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.943 478.632-314.625-313.535c-1.24-4.23-5.143-6.321-9.774-6.321h-19.639c-5.628 0-9.191 3.562-9.191 9.191v18.261c0 5.628-4.562 11.19-10.191 11.19h-19.26c-5.628 0-9.191 3.562-9.191 9.19v19.639c0 4.631 2.091 8.533 6.321 9.774l166.002 166.997c26.009 3.643 50.418 19.826 62.213 48.555 14.514 35.347 48.939 58.427 87.149 58.427 28.253 0 53.105-12.269 70.186-31.368z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.196 509.877c-2.366-8.92-7.286-16.799-13.941-22.798l-172.74-172.74c-8.585-9.524-75.766 57.657-66.242 66.243l42.583 42.583c38.035-35.387 105.448-25.922 127.754 28.408 13.932 33.934 46.219 56.549 82.586 58.304z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.604 458.761-144.422-144.422c-8.585-9.524-75.766 57.657-66.242 66.243l129.381 129.381c36.005-.95 66.181-21.853 81.283-51.202z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.667,
    cy: 345.733,
    fill: "url(#SVGID_21_)",
    r: 46.908
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.667,
    cy: 345.733,
    fill: "url(#SVGID_22_)",
    r: 46.908
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.333,
    cy: 345.733,
    fill: "url(#SVGID_23_)",
    r: 46.908
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.333,
    cy: 345.733,
    fill: "url(#SVGID_24_)",
    r: 46.908
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m94.243 510c38.21 0 72.635-23.08 87.147-58.427 9.036-22.01 25.48-36.646 44.371-43.932h-225.379c-4.826 54.105 37.827 102.359 93.861 102.359z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.618 407.641h-225.379c18.891 7.286 35.335 21.922 44.371 43.932 14.512 35.347 48.937 58.427 87.147 58.427 56.034 0 98.687-48.254 93.861-102.359z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m281.667 182.514h-53.333c-14.175 0-25.667-11.491-25.667-25.667 0-14.175 11.491-25.667 25.667-25.667h53.333c14.175 0 25.667 11.491 25.667 25.667-.001 14.176-11.492 25.667-25.667 25.667z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.186 196.418h-18.26c-5.628 0-10.191-4.562-10.191-10.191v-18.261c0-5.628-4.562-10.191-10.191-10.191h-19.639c-5.628 0-10.191 4.562-10.191 10.191v18.261c0 5.628-4.562 10.191-10.191 10.191h-18.26c-5.628 0-10.191 4.562-10.191 10.191v19.639c0 5.628 4.562 10.191 10.191 10.191h18.26c5.628 0 10.191 4.562 10.191 10.191v18.26c0 5.628 4.562 10.191 10.191 10.191h19.639c5.628 0 10.191-4.562 10.191-10.191v-18.26c0-5.628 4.562-10.191 10.191-10.191h18.26c5.628 0 10.191-4.562 10.191-10.191v-19.639c0-5.629-4.563-10.191-10.191-10.191z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.186 196.418h-18.26c-5.628 0-10.191-4.562-10.191-10.191v-18.261c0-5.628-4.562-10.191-10.191-10.191h-19.639c-5.628 0-10.191 4.562-10.191 10.191v18.261c0 5.628-4.562 10.191-10.191 10.191h-18.26c-5.628 0-10.191 4.562-10.191 10.191v19.639c0 5.628 4.562 10.191 10.191 10.191h18.26c5.628 0 10.191 4.562 10.191 10.191v18.26c0 5.628 4.562 10.191 10.191 10.191h19.639c5.628 0 10.191-4.562 10.191-10.191v-18.26c0-5.628 4.562-10.191 10.191-10.191h18.26c5.628 0 10.191-4.562 10.191-10.191v-19.639c0-5.629-4.563-10.191-10.191-10.191z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.926 211.418c-13.912 0-25.19-11.278-25.19-25.19v-8.442c0-2.767-2.243-5.01-5.01-5.01-2.767 0-5.01 2.243-5.01 5.01v8.442c0 13.912-11.278 25.19-25.19 25.19h-8.441c-2.767 0-5.01 2.243-5.01 5.01 0 2.767 2.243 5.01 5.01 5.01h8.441c13.912 0 25.19 11.278 25.19 25.19v8.441c0 2.767 2.243 5.01 5.01 5.01 2.767 0 5.01-2.243 5.01-5.01v-8.441c0-13.912 11.278-25.19 25.19-25.19h8.441c2.767 0 5.01-2.243 5.01-5.01 0-2.767-2.243-5.01-5.01-5.01z",
    fill: "url(#SVGID_30_)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9f6cc64bfd4c1d4c0c7eb2aade3eeb9b.svg";
export { ForwardRef as ReactComponent };